import React from "react";
import CustomCardII from "./CardII";
import { useEffect } from "react";
import { current } from "@reduxjs/toolkit";

const CardsStatus = ({ img, text1, text2, data1, data2, itemName, buttonTitle1 = "", buttonTitle2 = "", buttonIClassname = "", buttonIIClassname = "", buttonClick }) => {
  return (
    <div className="grid grid-cols-2 gap-0 border rounded-md shadow-md">
      <div className="border-r px-4 bg-red-50 pb-4">
        <div className="p-5 text-xl font-medium">{text1}</div>
        <div className="grid grid-cols-2 gap-4">
          {data1.map((item) => {
            const currItem=item;
            return (
              <CustomCardII
                image={img}
                title={currItem?.label}
                subtitleI={`${currItem?.make_details?.make_name} - ${currItem?.model_details.model_name}`}
                subtitleII={currItem?.veh_type_details?.type_name}
                subtitleIII={currItem?.veh_subtype_details?.sub_type_name}
                clickFun={() => {
                  buttonClick({ ...currItem, img }, true);
                }}
                buttonTitle={buttonTitle1}
                buttonClassName={buttonIClassname}
                // emiission={currItem?.distance_usage?.co2_emission_tones}
              />
            );
          })}
        </div>
      </div>
      <div className="px-4 pb-3 bg-green-50">
        <div className="p-5 text-xl font-medium">{text2}</div>
        <div className="grid grid-cols-2 gap-4">
          {data2.map((item) => {
            const currItem = item;
            return (
              <CustomCardII
                image={img}
                title={currItem?.label}
                subtitleI={`${currItem?.make_details?.make_name} - ${currItem?.model_details?.model_name}`}
                subtitleII={currItem?.veh_type_details?.type_name}
                subtitleIII={currItem?.veh_subtype_details?.sub_type_name}
                clickFun={() => {
                  const obj = { ...currItem, ...item, img }
                  delete obj?.[itemName];
                  buttonClick(obj, false)
                }}
                buttonTitle={buttonTitle2}
                buttonClassName={buttonIIClassname}
                isEdit={true}
                emission={currItem?.distance_usage?.co2_emission_tones || currItem?.co2_emission_tones}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardsStatus;
